<!-- <script>
// import { useCommonStore } from '@/stores';
// store = useCommonStore();
export default {
    created(){
        window.addEventListener("resize", this.resizeHandler)
    },
    destroyed(){
        window.removeEventListener("resize", this.resizeHandler)
    },
  methods: {
      resizeHandler(){
          // if (this.$refs.appnav) {
          //     store.navHeight = this.$refs.appnav.clientHeight
          // }
      },
      menuItemClick() {
          this.$refs.navMenu.classList.remove("show")
      },

  }
}
</script> -->

<script setup>
import { onMounted, ref, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { useAuthStore, useCompanyStore, useObjectStore, useEntrancesStore } from "@/stores";
import { useNotification } from "@kyvg/vue3-notification";
import { router } from "@/router";

import LogoIcon from "./icons/IconLogo.vue";
import navItem from "./NavItem.vue";

const authStore = useAuthStore();
const companyStore = useCompanyStore();
const objStore = useObjectStore();
const entrancesStore = useEntrancesStore();
const { notify } = useNotification();
const navMenu = ref(null);
const showLogoutModal = ref(false);

const { isAuthentificated, isAdmin } = storeToRefs(authStore);

onMounted(async () => {
    if (authStore.isAuthentificated) await companyStore.init();
});

watch(isAuthentificated, async (val) => {
    if (val) {
        await companyStore.init();
    } else {
        companyStore.items = [];
        objStore.items = [];
    }
});

function hideMenu() {
    navMenu.value.classList.remove("show");
}

function openLogoutModal() {
    hideMenu();
    showLogoutModal.value = true;
}

function confirmLogout() {
    showLogoutModal.value = false;
    const name = authStore.user?.name;
    authStore.logout();
    entrancesStore.clear(true);
    notify({
        title: "Авторизация",
        text: `${name ? name + ", вы" : "Вы"} вышли из аккаунта`,
        type: "success",
    });
    router.push("/account/login");
}

const canSeeObjects = computed(() => {
    const allowed = ["write", "manage", "admin"];
    return (
        companyStore.items.some((c) => allowed.includes(c.permission)) ||
        objStore.items.some((o) => allowed.includes(o.permission))
    );
});
</script>

<template>
    <nav
        class="navbar sticky-top navbar-expand-md bg-light filledgray p-0 m-0"
        ref="appnav"
    >
        <div class="container-lg">
            <router-link to="/" class="navbar-brand my-brand">
                <LogoIcon />
            </router-link>
            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div
                class="collapse me-auto navbar-collapse justify-content-between"
                id="navbarSupportedContent"
                ref="navMenu"
            >
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <navItem link="/" @click="hideMenu()">О продукте</navItem>
                    <navItem link="/about" @click="hideMenu()">О компании</navItem>
                    <navItem link="/docs" @click="hideMenu()">Документация</navItem>
                </ul>
                <div class="d-flex">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <navItem
                            v-if="canSeeObjects"
                            link="/objects"
                            @click="hideMenu()"
                            class="dropdown-item"
                            >Объекты</navItem
                        >
                        <navItem
                            v-if="isAdmin"
                            link="/users"
                            @click="hideMenu()"
                            class="dropdown-item"
                            >Пользователи</navItem
                        >
                        <navItem
                            v-if="isAuthentificated"
                            link="/account"
                            @click="hideMenu()"
                            class="dropdown-item"
                            >Профиль</navItem
                        >
                        <navItem
                            v-if="!isAuthentificated"
                            link="/account/login"
                            @click="hideMenu()"
                            class="dropdown-item"
                            >Войти</navItem
                        >
                        <navItem v-else @click="openLogoutModal" class="dropdown-item">Выйти</navItem>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
    <Teleport to="body">
        <div v-if="showLogoutModal" class="modal fade show d-block" tabindex="-1" @click.self="showLogoutModal = false">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header py-2">
                        <h6 class="modal-title">Выход из аккаунта</h6>
                    </div>
                    <div class="modal-body">
                        Вы уверены, что хотите выйти?
                    </div>
                    <div class="modal-footer py-2">
                        <button type="button" class="btn btn-secondary btn-sm" @click="showLogoutModal = false">Отмена</button>
                        <button type="button" class="btn btn-danger btn-sm" @click="confirmLogout">Выйти</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showLogoutModal" class="modal-backdrop fade show"></div>
    </Teleport>
</template>

<style scoped>
.navbar {
    margin-left: -12px;
    margin-right: -12px;
    border-bottom: 2px solid var(--clr-yellow);
}
.my-brand {
    padding-left: 1.2rem;
}
.filledgray {
    background-color: white;
}
.linkhref {
    text-decoration: none;
    color: black;
}
</style>
